var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.145,
    height: 18.146,
    viewBox: "0 0 18.145 18.146",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edit",
    transform: "translate(-1.15 -1.029)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2709",
    "data-name": "Group 2709",
    transform: "translate(1.15 1.029)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2046",
    "data-name": "Path 2046",
    d: "M15.117,19.548H3.581A2.434,2.434,0,0,1,1.15,17.117V5.581A2.434,2.434,0,0,1,3.581,3.15H9.349a.783.783,0,0,1,0,1.566H3.581a.866.866,0,0,0-.865.865V17.117a.866.866,0,0,0,.865.865H15.117a.866.866,0,0,0,.865-.865V11.349a.783.783,0,1,1,1.566,0v5.768A2.434,2.434,0,0,1,15.117,19.548Z",
    transform: "translate(-1.15 -1.402)",
    fill: "#00246a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2047",
    "data-name": "Path 2047",
    d: "M17.821,1.029a2.531,2.531,0,0,1,1.79,4.321l-7.828,7.828a.783.783,0,0,1-.364.206l-3.3.824a.783.783,0,0,1-.949-.949L8,9.962A.783.783,0,0,1,8.2,9.6L16.031,1.77A2.514,2.514,0,0,1,17.821,1.029ZM10.829,11.917,18.5,4.242a.965.965,0,1,0-1.365-1.365L9.464,10.552l-.455,1.82Z",
    transform: "translate(-2.206 -1.029)",
    fill: "#00246a"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.5468149157ebf5daaeb03547e5552d99.svg";
export { ForwardRef as ReactComponent };